// extracted by mini-css-extract-plugin
export var content = "_cl-3";
export var list = "_cl-4";
export var settingsContent = "_cl-7";
export var settingsPanel = "_cl-8";
export var state = "_cl-6";
export var triggerBadge = "_cl-2";
export var triggerButton = "_cl-1";
export var triggerShell = "_cl-0";
export var unreadDot = "_cl-5";